<script lang="ts" setup>
import { ref, toRefs } from 'vue';
import VInputMask from '@shared/form/VInputMask/VInputMask.vue';
import { friendlyFormatIBAN } from 'ibantools';

const props = withDefaults(
  defineProps<{
    id: string;
    placeholder?: string;
    readonly?: boolean;
    disabled?: boolean;
    modelValue?: string | undefined;
  }>(),
  {
    readonly: false,
    disabled: false,
    placeholder: 'NL XX BANK 1234 1234 00',
  },
);
const emit = defineEmits<{
  'update:modelValue': [value: string | undefined];
  blur: [];
}>();

const { id, disabled, placeholder, readonly } = toRefs(props);

const iban = defineModel<string | undefined>();

const applyMask = ref(true);

function onFocus() {
  applyMask.value = false;
}

function onBlur() {
  applyMask.value = true;
  iban.value = iban.value?.replace(/\s/g, '');
  emit('blur');
}
</script>

<template>
  <VInputMask
    v-if="!readonly"
    class="uppercase"
    data-testid="iban-field__input"
    :disabled
    :id
    :mask="{
      mask: '@@## **** **** ***0 0000 0000 0000 0000 00',
      tokens: {
        0: {
          pattern: /[a-zA-Z0-9]/,
          optional: true,
        },
      },
    }"
    :model-value="iban"
    :placeholder
    :unmask="applyMask"
    @blur="onBlur"
    @focus="onFocus"
    @update:model-value="(value: string | null | undefined) => (iban = value?.toUpperCase())"
  />
  <div v-else class="filled group-[&]/float-label:h-11 group-[&]/float-label:content-center">
    {{ friendlyFormatIBAN(iban) || '-' }}
  </div>
</template>
